import { GLOBAL_MARGIN_HORIZONTAL } from 'src/app/constants';

export const connectAppsStyles = {
  container: {
    mt: GLOBAL_MARGIN_HORIZONTAL * 2,
    mb: GLOBAL_MARGIN_HORIZONTAL,
  },
  appsList: {
    mt: 2,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 3,
    rowGap: 3,
    columnGap: 3,
    justifyContent: 'flex-start',
  },
  appItem: {
    p: 2,
    border: '1px solid #eee',
    borderRadius: 2,
    background: '#fafbfc',
    boxShadow: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    minWidth: 220,
    maxWidth: 320,
    flex: '1 1 240px',
    boxSizing: 'border-box',
  },
};
